import { WEBENGAGE_EVENT_KEYS } from 'src/common/constants';
import { localStorageGet } from 'src/common/local-storage';
import { LOCAL_STORAGE_KEYS } from 'src/common/local-storage/constants';

export const trackWebEngageEvent = (
  eventKey: (typeof WEBENGAGE_EVENT_KEYS)[keyof typeof WEBENGAGE_EVENT_KEYS],
  params?: object,
) => {
  try {
    webengage.track(eventKey, {
      ...params,
      userId: localStorageGet(LOCAL_STORAGE_KEYS.USER_ID) ?? '',
      time: new Date(),
      timestamp: +new Date(),
    });
  } catch (error) {
    console.error('Failed to send Webengage event', eventKey);
  }
};
